<template>
  <div>
    <el-tooltip placement="bottom-end">
      <div slot="content" style="font-size:10px">ストーリーズトラッキング</div>
      <div class="data-table-th-favorite stories" @click="changeStories()" :class="[referer == 'list' || referer == 'report' ? 'list' : '']">
        <img src="../../assets/stories_grey.png" alt="" style="width:14px" />
      </div>
    </el-tooltip>
    <el-tooltip placement="bottom-end">
      <div slot="content" style="font-size:10px">ストーリーズトラッキングを解除</div>
      <div class="data-table-th-picture-favorite stories" :class="referer == 'list' || referer == 'report' ? 'list' : ''" @click="Untracking()" v-if="stories">
        <img src="../../assets/stories_blue.png" alt="" style="width:14px" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeStoriesTrackAPI = root + "/api/search/change_stories_track";

export default {
  name: "stories",
  props: ["stories", "index", "referer", "ig_id"],
  components: {},
  data() {
    return {};
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    changeStories() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("ig_id", this.ig_id);
      params.append("tracking", !this.stories);
      this.axios
        .post(changeStoriesTrackAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.$emit("update:stories", !this.stories);
            this.$emit("storiesReactive", this.index)
          } else {
            this.$message({
              message: response.data.message,
              type: "error",
              offset: 7,
            });
          }
        })
        .catch(() => {});
    },
    Untracking() {
      this.$alert("一度トラッキングを解除すると以前のストーリーズは閲覧できなくなります。", "ストーリーズトラッキングを解除", {
        showCancelButton: true,
        confirmButtonText: "解除",
        cancelButtonText: "キャンセル",
        type: "warning",
      }).then(() => {
        this.changeStories();
      }).catch(() => {
        // キャンセル時は何も表示しない
        return;
      });
    },
  },
};
</script>

<style></style>
